module.exports = __webpack_public_path__ + "img/formats-4.e1e91992.png";